<div *ngIf="!show" class="container containerCashOutTitle pt-4">
  <h2>{{ 'components.menu.cash_out_page.transfer_result' | translate }}</h2>
  <mat-spinner *ngIf="loading" color="primary" mode="indeterminate" diameter="50"></mat-spinner>
</div>

<div *ngIf="paymentInProgress" class="containerCashOutTitle py-4">
  <mat-spinner *ngIf="loading" color="primary" mode="indeterminate" diameter="50"></mat-spinner>
</div>

<div *ngIf="show && !paymentInProgress" class="container container-transfer">
  <h1 class="mt-3 pl-2">Transferencias</h1>
  <mat-horizontal-stepper [linear]="true" #stepper>
    <mat-step [stepControl]="formDestinatario">
      <div class="centerAll">
        <form [formGroup]="formDestinatario" class="formulario">
          <ng-template matStepLabel><b>{{ 'components.menu.cash_out_page.label_step2' | translate }}</b></ng-template>

          <!-- RADIO BUTTONS -->
          <span class="title-radio-button">{{ 'components.recipients.enter' | translate }}</span>
          <mat-radio-group aria-label="Select an option" class="centerAll d-inline-flex flex-row gap-4">
            <mat-radio-button class="w-auto" value="alias" #checkAlias color="primary" checked name="formaTransferencia"
              (change)="formaATransferir($event)">{{ 'pages.cash-out.alias' | translate }}</mat-radio-button>
            <mat-radio-button class="w-auto" value="agenda" color="primary" name="formaTransferencia"
              (change)="formaATransferir($event)">{{ 'pages.cash-out.agenda' | translate }}</mat-radio-button>
          </mat-radio-group>

          <div *ngIf="!showRecipients" class="containerStep1">
            <div class="containerInputAndButton">
              <!-- INPUT PARA INGRESAR CBU/CVU/ALIAS -->
              <mat-form-field *ngIf="showCBU" class="input-yaca">
                <mat-label>{{ 'components.menu.cash_out_page.cash_enter_cvu' | translate }}</mat-label>
                <input [(ngModel)]="campoCBU" matInput id="inputCBU" autocomplete="off" required
                  formControlName="inputCBU" maxlength="22" minlength="6" (paste)="checkPaste($event)"
                  (drop)="checkDrop($event)" (keypress)="checkPattern($event)" />
                <mat-error>{{ 'components.menu.cash_out_page.cash_error_cvu' | translate }}</mat-error>
              </mat-form-field>

              <mat-form-field *ngIf="!showCBU" class="input-yaca">
                <mat-label>{{ 'components.menu.cash_out_page.cash_enter_alias' | translate }}</mat-label>
                <input [(ngModel)]="campoCBU" matInput id="inputCBU" autocomplete="off" required
                  formControlName="inputCBU" maxlength="22" minlength="6" />
                <mat-error>{{ 'components.menu.cash_out_page.cash_error_alias' | translate }}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div *ngIf="showRecipients" class="containerStep1">
            <app-select-recipients #selectRecipients class="w-100" [recipients]="recipients"
              (onRecipientDeleted)="deleteRecipients($event)" (RecipientSelected)="setAliasCBU($event)"
              (onClosedRecipientList)="mostrarDestinatarios()"></app-select-recipients>
          </div>

          <div class="buttonsContainer">
            <button mat-stroked-button matStepperPrevious class="button-stroked" (click)="goBack()"
              style="margin: 0.5rem">
              Salir
            </button>
            <button type="button" mat-raised-button matStepperNext [ngClass]="{ 'button-next': camposValidos() }"
              (click)="verificarCVU()" style="margin: 0.5rem" color="primary" [disabled]="!camposValidos()">
              {{ 'commons.buttons.next' | translate }}
            </button>
          </div>
        </form>
      </div>
    </mat-step>

    <mat-step [stepControl]="formMonto">
      <span class="not-matching-cuit-label pt-4" *ngIf="!cuitMatches && !loading">
        <img src="../../../assets/icons/alert-triangle-red.svg" alt="alert-icon" width="18px" height="18px" />
        Sólo puede transferir a cuentas de su propia titularidad</span>
      <form [formGroup]="formMonto" class="form-amount">
        <ng-template matStepLabel><b>{{ 'components.menu.cash_out_page.label_step1' | translate }}</b></ng-template>

        <div class="containerCashOutTitle pt-4" *ngIf="!isConsultaCVU && !loading">
          <div class="contentInfo">
            <div class="info-destinatario">
              <span class="title-dest">CBU/CVU/Alias:</span>
              <span class="subtitle-dest">{{ this.deleteSpaces(this.formDestinatario.value?.inputCBU) }}</span>
              <br />
              <span class="title-dest">CUIL/CUIT:</span>
              <span class="subtitle-dest">{{ maskCuit(cashOut.cuit) }}</span>
              <br />
              <span class="title-dest">Titular:</span>
              <span class="subtitle-dest">{{ cashOut.titular }}</span>
            </div>
          </div>
        </div>
        <div class="py-4 centered w-100 d-inline-flex justify-content-center" *ngIf="loading">
          <mat-spinner *ngIf="loading" style="stroke: #ff6600" mode="indeterminate" diameter="50"></mat-spinner>
        </div>

        <div *ngIf="!loading && isConsultaCVU" class="enterAmount pt-3">
          <span class="balance-available px-4">{{
            'dialog_cash.labels.validations.user_notfound_label' | translate
            }}</span>
        </div>

        <div *ngIf="!loading && !isConsultaCVU" class="enterAmount pt-3">
          <span>{{ 'components.menu.cash_out_page.enter_amount' | translate }}</span>
        </div>

        <div *ngIf="!loading && !isConsultaCVU" class="containerCashOutTitle pt-1">
          <mat-form-field class="input-yaca input-currency">
            <input matInput #currencyInput [ngModel]="cashOutInputCurrency" formControlName="comercioMonto"
              (ngModelChange)="monto = currencyInputChanged($event)" autocomplete="off" appCurrencyValidator type="tel"
              class="currency-input" />
            <mat-error *ngIf="!this.montoDown">{{ getErrorMessage(6) }}</mat-error>
            <mat-error *ngIf="!this.montoDown">{{ getError }}</mat-error>
          </mat-form-field>
        </div>

        <div *ngIf="!loading && !isConsultaCVU" class="enterAmount pt-3">
          <span class="balance-available px-4">{{ 'components.menu.cash_out_page.amount_available' | translate }} <b>{{
              balanceAvailable }}</b></span>
        </div>

        <div *ngIf="!loading" class="containerCashOutTitle py-3">
          <button mat-raised-button matStepperPrevious (click)="resetFormCashOut()" class="button-stroked"
            style="margin: 0.5rem">
            {{ 'commons.buttons.back' | translate }}
          </button>
          <button type="button" mat-raised-button matStepperNext style="margin: 0.5rem" color="primary"
            [ngClass]="{ 'button-next': montoDown, 'next-disabled': !cuitMatches }" (click)="
              consultaCVU(); nextStep(this.formDestinatario.value.inputCBU); checkRecipient(this.cashOut.titular)
            " [disabled]="!montoDown || !cuitMatches">
            {{ 'commons.buttons.next' | translate }}
          </button>
        </div>
      </form>
    </mat-step>

    <!-- PASO 3 -->
    <mat-step [stepControl]="formConfirmar">
      <form [formGroup]="formConfirmar">
        <ng-template matStepLabel><b>{{ 'components.menu.cash_out_page.label_step3' | translate }}</b></ng-template>

        <div *ngIf="!loading" class="enterAmount pt-3">
          <span class="balanceAvailable px-4">{{ 'components.menu.cash_out_page.enter_amount' | translate }} <b>{{
              cashOutInputCurrency }}</b></span>
        </div>

        <div *ngIf="!loading" class="containerCashOutTitle pt-4">
          <div class="contentInfo" *ngIf="!isConsultaCVU">
            <div class="info-destinatario">
              <span class="title-dest">CBU/CVU/Alias:</span>
              <span class="subtitle-dest">{{ this.formDestinatario.value.inputCBU }}</span>
              <br />
              <span class="title-dest">CUIL/CUIT:</span>
              <span class="subtitle-dest">{{ maskCuit(cashOut.cuit) }}</span>
              <br />
              <span class="title-dest">Titular:</span>
              <span class="subtitle-dest">{{ cashOut.titular }}</span>
            </div>

            <section class="checkbox-guardar" *ngIf="!isRecipient">
              <mat-checkbox [checked]="habilitarGuardado" (change)="cambiarHabilitarGuardado(habilitarGuardado)"
                color="primary" class="checkbox-save-recipient" [disabled]="isRecipient">{{
                'pages.cash-out.save-recipient' | translate }}</mat-checkbox>
            </section>
          </div>
        </div>
        <div *ngIf="loading" class="pb-3 centered w-100 d-inline-flex justify-content-center">
          <mat-spinner style="stroke: #ff6600" mode="indeterminate" diameter="50"></mat-spinner>
        </div>

        <div *ngIf="!loading" class="containerCashOutTitle button-content pt-3 gap-4">
          <div class="align-content-center d-inline-flex w-100 gap-4">
            <button mat-raised-button matStepperPrevious type="button"
              (click)="verificarCVU(); cashOutInputCurrency = '$0,00'" class="button-stroked w-100 m-0">
              {{ 'commons.buttons.back' | translate }}
            </button>
            <button mat-raised-button matStepperPrevious class="button-stroked w-100 m-0"
              (click)="cancelTx(); stepper.reset(); consultaCVU()">
              {{ 'dialog_confirm.buttons.cancel' | translate }}
            </button>
          </div>
          <button class="mt-2" type="submit" *ngIf="!isConsultaCVU" (click)="transferir()" mat-raised-button
            style="margin: 0.5rem; width: 100%" tabindex="0" color="primary" [class.spinner]="loading"
            [ngClass]="{ 'button-next': !loading }" [disabled]="loading">
            {{ 'commons.buttons.transfer' | translate }}
          </button>
        </div>
      </form>
    </mat-step>
  </mat-horizontal-stepper>
</div>

<!-- RESULTADOS DE TRANSFERENCIAS -->

<div *ngIf="transferOK" class="container container2">
  <span class="iconfirm">
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="green" class="bi bi-check2-circle"
      viewBox="0 0 16 16">
      <path
        d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
      <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
    </svg>
  </span>
  <div class="transfer-title mb-3">
    <span>{{ 'components.transfer_text.text_transfer_1' | translate }}</span><br />
    <span class="negrita amount">{{ cashOutInputCurrency }}</span><br />
    <span>{{ 'components.transfer_text.text_transfer_2' | translate }}</span><br />
    <span class="negrita">{{ cashOut.titular }}</span><br /><br />
    <span>{{ 'components.transfer_text.text_transfer_ok' | translate }}</span>
  </div>
  <div class="align-items-center w-100 gap-4 mb-4 mt-2 buttons-container">
    <button mat-raised-button (click)="showMovements()" class="button-stroked w-100 m-0">
      {{ 'dialog_confirm.buttons.show_movements' | translate }}
    </button>
    <button mat-raised-button (click)="retry()" class="button-next w-100 m-0" tabindex="0" color="primary"
      [class.spinner]="loading" [disabled]="loading">
      {{ 'commons.buttons.new_transfer' | translate }}
    </button>
  </div>
</div>

<div *ngIf="transferErr" class="container container2">
  <span class="iconfirm">
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="red" class="bi bi-x-circle"
      viewBox="0 0 16 16">
      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
      <path
        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
  </span>
  <div class="transfer-title">
    <span>{{ 'components.transfer_text.text_transfer_1' | translate }}</span><br />
    <span class="negrita amountErr">{{ cashOutInputCurrency }}</span><br />
    <span>{{ 'components.transfer_text.text_transfer_2' | translate }}</span><br />
    <span class="negrita">{{ cashOut.titular }}</span><br /><br />
    <span>{{ 'components.transfer_text.text_transfer_error' | translate }}</span><br />
    <span class="negrita">{{ error }}</span>
  </div>
  <br />
  <div>
    <button mat-raised-button (click)="retry()" tabindex="0" class="font-clear" color="primary"
      [class.spinner]="loading" [disabled]="loading">
      {{ 'pay_form.buttons.retry' | translate }}
    </button>
  </div>
</div>